import { AppState } from '@Redux/store';
import { Locale, UserPreference, VersionGame, VersionInterface } from '@Models';

export const getUserPreference = (state: AppState): UserPreference => {
  return (
    state.userPreference.entity ??
    ({
      id: '',
      email: '',
      name: '',
      game: VersionGame.NinthAge,
      builderInterface: VersionInterface.Classic,
      useLatestVersion: false,
      isGuest: true,
      defaultLocale: Locale.EN,
      location: null,
    } satisfies UserPreference as UserPreference)
  );
};
